import { Container } from '../types/container';
import { http } from '../util/https.util';
import { PaginatedResponse } from './common/paginatedResponse';

const LIST = '/api/container/list';

export namespace ContainerRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<Container>> => {
    return (await http.post(LIST, payload)).data;
  };
}
